module.exports = __webpack_public_path__ + "static/media/calenderGrey.c8197852.svg";